import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import { PO_TEMPLATES } from "../../constants/templates";
import { getAuthUser, getUserLocation } from "../../redux";
import {
  useGetOrderEditData,
  useGetShipmentDetails,
  usePutOrderData,
} from "../../hooks";
import { DocuBuilder, HubHookFormWrapper } from "../../components";
import { CreateMaterialDialog, ManageMoldDialog } from "../../dialogs";

import PurchaseOrderOrderDetails from "./PurchaseOrderOrderDetails";
import { getDefaultValues, getUpdatePayload } from "./helper";

const PurchaseOrderBuilderUnconnected = ({ user = {}, id }) => {
  const navigate = useNavigate();

  const [searchParms] = useSearchParams();
  const shipmentId = searchParms.get("shipmentId");

  const { data, isLoading } = useGetOrderEditData(Number(id));
  const { mutate: update, isSuccess } = usePutOrderData(true);

  // We only want to pull from shipment data
  // if we do not have a created order
  const getShipment = !(data?.id || Number(id)) && shipmentId;
  const { data: shipment } = useGetShipmentDetails(getShipment);

  useEffect(() => {
    if (!isSuccess) return;

    if (id) window.location.reload();
    else navigate(`/orders/${newOrder?.id}?isVendor=true`);
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const newData = getUpdatePayload(formData);
    const payload = { id, ...newData };
    update(payload);
  };

  const { nonEditable, defaultValues } = getDefaultValues(data, shipment, user);
  const Template = PO_TEMPLATES[0]?.Template;

  return (
    <>
      <HubHookFormWrapper
        onSubmit={onSubmit}
        sx={{ height: "100%" }}
        defaultValues={defaultValues}
      >
        <DocuBuilder
          id={id}
          name={null}
          title={data?.name || "New Vendor Order"}
          data={nonEditable}
          label="Vendor Order"
          isPreview={false}
          includeName={true}
          disabled={false}
          isLoading={isLoading}
          Template={Template}
          FormComponent={
            <PurchaseOrderOrderDetails id={id} isLoading={isLoading} />
          }
        />
      </HubHookFormWrapper>
      <CreateMaterialDialog />
      <ManageMoldDialog />
    </>
  );
};

const mapStateToProps = (state) => ({
  user: getAuthUser(state),
  locationId: getUserLocation(state),
});
export const PurchaseOrderBuilderPage = connect(mapStateToProps)(
  PurchaseOrderBuilderUnconnected,
);
export default PurchaseOrderBuilderPage;
